import { render, staticRenderFns } from "./divider-widget.vue?vue&type=template&id=200e385a&scoped=true"
import script from "./divider-widget.vue?vue&type=script&lang=js"
export * from "./divider-widget.vue?vue&type=script&lang=js"
import style0 from "./divider-widget.vue?vue&type=style&index=0&id=200e385a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e385a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200e385a')) {
      api.createRecord('200e385a', component.options)
    } else {
      api.reload('200e385a', component.options)
    }
    module.hot.accept("./divider-widget.vue?vue&type=template&id=200e385a&scoped=true", function () {
      api.rerender('200e385a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/divider-widget.vue"
export default component.exports